'use client'

import { YDLogo } from 'design-system'

export const Logo = () => <YDLogo className="self-center" />
